import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ewm.jpg'
import _imports_1 from '../assets/but1.png'


const _withScopeId = n => (_pushScopeId("data-v-156c16c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "but" }
const _hoisted_2 = { class: "card-wrap" }
const _hoisted_3 = { class: "d-f j-c introduction p-r ov" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"right t-c\" data-v-156c16c4><img src=\"" + _imports_0 + "\" data-v-156c16c4><div class=\"f14 cb4\" data-v-156c16c4>扫码关注公众号</div></div><div class=\"center p-r\" data-v-156c16c4><div class=\"f18 cff\" data-v-156c16c4>联系我们</div><div class=\"f14 cb4\" data-v-156c16c4>客服电话：18031089711</div><div class=\"f14 cb4\" data-v-156c16c4>投诉建议：xinkao666@126.com</div><div class=\"f14 cb4\" data-v-156c16c4>公司地址：河北省邯郸市肥乡区振兴路</div><div class=\"p-a\" data-v-156c16c4></div></div>", 2)
const _hoisted_6 = { class: "buttom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cff f20" }, "软件下载", -1))
const _hoisted_8 = { class: "d-f f14 t-c" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "d-f but1 cff" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  style: {"background-color":"#0FC658 !important"},
  class: "d-f but1 cff"
}
const _hoisted_14 = {
  target: "_blank",
  href: "https://pan.baidu.com/s/1-HYwjiTBAGwcdUHZ3ap-hg?pwd=6q6v"
}
const _hoisted_15 = {
  style: {"background-color":"#C67D0F !important"},
  class: "d-f but1 cff"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cff f14" }, "安装时，请关闭电脑杀毒软件和防火墙", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"color":"rgba(255,255,255,.4)"},
  class: "t-c cff f14 Copyright"
}, [
  /*#__PURE__*/_createTextVNode(" Copyright © 2019 河北早晨智能科技有限公司 "),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"rgba(255,255,255,.4)"},
    href: "https://beian.miit.gov.cn",
    target: "_blank"
  }, "冀ICP备2023029112号-1")
], -1))

import { ref, onMounted, onUnmounted, nextTick } from "vue";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'bottom',
  props: {
      releasess: Object,
      releasess_: Object,
    },
  setup(__props) {

  const prop = __props;
  const phoneshow = ref<Number>(false);
  const show = ref<Number>(0);
  const screenWidth = ref(window.innerWidth);
  const data = ref({
    oldScrollTop: 0,
  });
  
  const handleResize = () => {
    screenWidth.value = window.innerWidth;
  };
  
  onMounted(() => {
    window.addEventListener("scroll", scrolling);
    window.addEventListener('resize', handleResize);
    nextTick(() => {
      document.oncontextmenu = new Function("event.returnValue=false");
      document.onselectstart = new Function("event.returnValue=false");
      document.addEventListener("keydown", function (e) {
        if (e.key == "F12") {
          e.preventDefault(); // 如果按下键F12,阻止事件
        }
      });
    })
  });
  onUnmounted(() => {
    window.removeEventListener("scroll", scrolling);
    window.removeEventListener('resize', handleResize);
  });
  const background = ref(0);
  const scrolling = () => {
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    let scrollStep = scrollTop - data.oldScrollTop;
    if (scrollTop >= 48) {
      background.value = 1;
    } else if (scrollTop <= 48) {
      background.value = 0;
    }
  
  };
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                href: prop.releasess
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(" Windows版下载 ")
                ], 512), [
                  [_vShow, screenWidth.value > 740]
                ])
              ], 8, _hoisted_9),
              _createElementVNode("a", {
                href: prop.releasess_
              }, [
                _withDirectives(_createElementVNode("div", _hoisted_13, " 备用下载地址一 ", 512), [
                  [_vShow, screenWidth.value > 740]
                ])
              ], 8, _hoisted_12),
              _createElementVNode("a", _hoisted_14, [
                _withDirectives(_createElementVNode("div", _hoisted_15, " 百度网盘下载 ", 512), [
                  [_vShow, screenWidth.value > 740]
                ])
              ])
            ]),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _hoisted_17
  ]))
}
}

})